module.exports = __webpack_public_path__ + "img/logo.0b372a7a.png";